import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";

export type EntityCommandUserDeletePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandUserDeleteProperties = {
    [name in keyof EntityCommandUserDeletePropertyValues]: Property<EntityCommandUserDeletePropertyValues[name]>
};

export interface IEntityCommandUserDelete extends IEntityCommand, EntityCommandUserDeleteProperties
{
}

export class EntityCommandUserDelete extends EntityCommand implements IEntityCommandUserDelete
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandUserDeletePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Delete",
                entityName: "User",
                key: "DELETE",
                permission: PermissionEvaluator.permissionLevels.delete,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected messageDialog?: MessageDialog;

    // #endregion

    // #region Constructors

    constructor(propertyValues?: PartialNullable<EntityCommandUserDeletePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        const
            self = this;

        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    if (!self.messageDialog)
                        self.messageDialog = new MessageDialog();

                    const
                        entitySetName = entityCommandInformation.entitySetName.get(),
                        record = entityCommandInformation.record.get();

                    if (!entitySetName)
                        return;

                    if (!record || !record.id)
                        return;

                    self.messageDialog.buttonStyle.set(ButtonStyleEnum.yesNo);
                    self.messageDialog.title.set("Delete User?");
                    self.messageDialog.text.set(StringHelper.format("Are you sure you want to delete the user \"{0}\"?", record ? record.username : "this user"));

                    return (
                        self.messageDialog
                            .openAsync()
                            .then(result =>
                            {
                                if (result.dialogResult === DialogResultEnum.yes)
                                {
                                    return (
                                        ServiceManager.getRequired(WebApiClientService)
                                            .createEntityDeleteRequest(
                                                entitySetName,
                                                record.id
                                            )
                                            .executeAsync()
                                    );
                                }

                                return Promise.reject("User cancelled");
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
    }

